import { mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery: breakpoint } = mediaQueryStyles;

export const pageFiltersContainerCss = (isSticky: boolean) => ({
  top: "0",
  display: "flex",
  flexDirection: "column" as const,
  justifyContent: "center",
  gap: "16px",
  margin: "8px 0 8px 0",
  padding: "16px 0 16px 0",
  backgroundColor: "white",
  zIndex: "12",

  "@media (min-width: 593px)": {
    position: "sticky" as const,
    flexDirection: "row" as const,
    justifyContent: "left",
    ...(isSticky && { boxShadow: "0px 4px 4px -4px rgba(0, 0, 0, 0.25)" }),
  },
});

export const studentFilterContainerCss = {
  width: "100%",

  [breakpoint.downTo("xs")]: {
    width: "100%",
  },

  [breakpoint.downTo("sm")]: {
    width: "36%",
  },

  [breakpoint.downTo("md")]: {
    width: "44%",
  },

  [breakpoint.downTo("lg")]: {
    width: "36%",
  },
};

export const activityFilterContainerCss = {
  width: "100%",

  [breakpoint.downTo("xs")]: {
    width: "100%",
  },

  [breakpoint.downTo("sm")]: {
    width: "32%",
  },
  [breakpoint.downTo("md")]: {
    width: "28%",
  },

  [breakpoint.downTo("lg")]: {
    width: "22%",
  },
};

export const dateFilterContainerCss = {
  width: "100%",

  [breakpoint.downTo("xs")]: {
    width: "100%",
  },

  [breakpoint.downTo("sm")]: {
    width: "36%",
  },
  [breakpoint.downTo("md")]: {
    width: "28%",
  },

  [breakpoint.downTo("lg")]: {
    width: "22%",
  },
};
